import { jsx, jsxs } from "react/jsx-runtime";
import { XStack } from "tamagui";
import { LinearGradient } from "tamagui/linear-gradient";
function LinearGradientDemo() {
  return /* @__PURE__ */ jsxs(XStack, { space: true, children: [
    /* @__PURE__ */ jsx(
      LinearGradient,
      {
        width: "$6",
        height: "$6",
        borderRadius: "$4",
        colors: ["$red10", "$yellow10"],
        start: [0, 1],
        end: [0, 0]
      }
    ),
    /* @__PURE__ */ jsx(
      LinearGradient,
      {
        width: "$6",
        height: "$6",
        borderRadius: "$4",
        colors: ["$background", "$color"],
        start: [1, 1],
        end: [0, 0]
      }
    )
  ] });
}
export {
  LinearGradientDemo
};
//# sourceMappingURL=LinearGradientDemo.js.map
